import { render } from "./DepositModal.vue?vue&type=template&id=c981313a&scoped=true"
import script from "./DepositModal.vue?vue&type=script&lang=js"
export * from "./DepositModal.vue?vue&type=script&lang=js"

import "./DepositModal.vue?vue&type=style&index=0&id=c981313a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c981313a"]])

export default __exports__